import React, { useEffect, useMemo, useState } from 'react';
import { List, Popover, Modal } from "tea-component";
import { delMenu } from '@/pages/dashboard/services/leftMenu';
import { useIntl, useDispatch, getLocale, connect } from 'umi';
import SvgIcon from '@/pages/home/components/SvgIcon';
const MenuModel = (props: any) => {
  const { menu, visible, setVisible, referenceElement, setModalInfoState, setActiveInfo, currentGame } = props;

  const { role_id: roleId = '',game_code: gameCode } = currentGame || {};
  // 只有系统管理员才能修改菜单（basic这一级）
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const locale = getLocale();

  const hancleClickRename = () => {
    setModalInfoState({
      show: true,
      type: 'edit',
      editType: 'menu',
      item: {...menu}
    });
    setVisible(false);
  }

  const hancleClickDel = () => {
    setVisible(false);
    const name = (locale ==='zh-CN' && menu?.name_cn) || menu?.name_en
    Modal.confirm({
      message: <div style={{ fontSize: '16px', fontWeight: '400' }}>
      <div style={{ fontWeight: 'bold' }}>
         {formatMessage({id:'menu_info_del_1'}) + formatMessage({id: 'menu'})}?
      </div>
      <div style={{ marginTop:'5px' }}>
        {formatMessage({id:'menu_info_del_2'})}
        <span style={{ fontWeight: 'bold'}}>{name}</span> ?
        <span> {formatMessage({id:'menu_info_del_3'})}</span>
      </div>
    </div>,
      okText: formatMessage({id:'menu_confirm'}),
      cancelText: formatMessage({id:'menu_cancel'}),
      onOk: doDelMenu
    });
  }

  // 删除菜单
  const doDelMenu = () => {
    delMenu({
      id: menu.id,
      game_code: gameCode,
    }).then(() => {
      dispatch({
        type: 'dashboard/getLeftMenuList',
      });
    }, (err) => {
    }).finally(() => {
    });
  }

  useEffect(() => {
    if (visible) {
      dispatch({
        type: "dashboard/save",
        payload: {
          showContentMask: true
        }
      });

      dispatch({
        type: 'home/save',
        payload: {
          showGlobalMask: 'transparent',
        },
      });
    } else {
      dispatch({
        type: "dashboard/save",
        payload: {
          showContentMask: false
        }
      });

      dispatch({
        type: 'home/save',
        payload: {
          showGlobalMask: false,
        },
      });
    }
    // setActiveInfo && setActiveInfo({
    //   id: menu?.id,
    //   show: visible,
    // })

    return () => {
      dispatch({
        type: "dashboard/save",
        payload: {
          showContentMask: false
        }
      });

      dispatch({
        type: 'home/save',
        payload: {
          showGlobalMask: false,
        },
      });
    };
  }, [visible]);
  return (
    <>
      {/*{onclick === 'true' ? <div className='dtd-db-left-menu-text'>*/}
      {<Popover
        referenceElement={referenceElement}
        visible={visible}
        onVisibleChange={visible => {setVisible(visible)}}
        placement="right-start"
        placementOffset={[-10, 27]}
        trigger="click"
        overlay={
          <div className='left-nav-exit'>
            <List type="option">
              <List.Item onClick={hancleClickRename}><div className='dbd-sub-nav'><SvgIcon type='rename-icon' className='dbd-sub-nav-icon'/><div className="dbd-sub-nav-text" >{formatMessage({ id: 'menu_rename' })}</div></div></List.Item>
              <List.Item onClick={hancleClickDel}><div className='dbd-sub-nav'><SvgIcon type='trash-can-icon' className='dbd-sub-nav-icon'/><div className="dbd-sub-nav-text" >{formatMessage({ id: 'menu_delete' })}</div></div></List.Item>
            </List>
          </div>
        }
      >
      {/*  <span className='left-nav-absolute'> <SvgIcon type="more"/></span>*/}
      </Popover>}
    </>
  );
}


export default connect((state: any) => {
  const { dashboard } = state;
  return {
    currentGame: dashboard.currentGame,
  }
})(MenuModel);
